import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../lib/config";

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("admin_token"));
  const [loading, setLoading] = useState(true);

  // Handle token expiry consistently
  useEffect(() => {
    const handler = () => logout();
    window.addEventListener("admin:logout", handler);
    return () => window.removeEventListener("admin:logout", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (token) {
      fetchAdmin();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const fetchAdmin = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdmin(response.data);
    } catch (error) {
      console.error("Failed to fetch admin:", error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API_BASE_URL}/admin/login`, { email, password });
    const { token: newToken, admin: adminData } = response.data;
    localStorage.setItem("admin_token", newToken);
    setToken(newToken);
    setAdmin(adminData);
    return adminData;
  };

  const logout = () => {
    localStorage.removeItem("admin_token");
    setToken(null);
    setAdmin(null);
  };

  const changePassword = async (newPassword) => {
    await axios.put(
      `${API_BASE_URL}/admin/change-password`,
      { new_password: newPassword },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  };

  return (
    <AdminContext.Provider value={{ admin, token, login, logout, loading, changePassword }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error("useAdmin must be used within an AdminProvider");
  }
  return context;
};
